import { render } from "./CookieDialog.vue?vue&type=template&id=f145f3d0&scoped=true"
import script from "./CookieDialog.vue?vue&type=script&lang=js"
export * from "./CookieDialog.vue?vue&type=script&lang=js"

import "./CookieDialog.vue?vue&type=style&index=0&id=f145f3d0&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f145f3d0"]])

export default __exports__